import { Route, Routes } from 'react-router-dom'
import { Box, Paper } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import PageHeader from 'components/AppBar/PageHeader'
import Protected from 'components/Protected'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import NotFound from 'components/NotFound'
import NotificationTabs, { tabConfig } from './Tabs'
import NotificationReport from './Report'
import SendNotification from './Send'

const basePath = '/notification'

export default function Notification() {
  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ mb: 1 }}>
        <PageHeader title={'Notification'} />
      </Box>
      <Paper sx={{ width: '100%', p: 2 }}>
        <NotificationTabs />
      </Paper>
      <Box>
        <Routes>
          <Route path="/">
            <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
            <Route
              path="report/*"
              element={
                <Protected permission="miscellaneous.notification">
                  <NotificationReport />
                </Protected>
              }
            />
            <Route
              path="send/*"
              element={
                <Protected permission="miscellaneous.notification">
                  <SendNotification />
                </Protected>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Box>
    </BasePathProvider>
  )
}
